import React, { useEffect } from "react"
import ReactModal from "react-modal"
import styles from "./modal.module.scss"

const Modal = React.memo(({ isOpen, ...props }) => {
  useEffect(() => {
    if (isOpen) {
      document.documentElement.classList.add("is_disableScroll")
    } else {
      document.documentElement.classList.remove("is_disableScroll")
    }
  }, [isOpen])
  return (
    <ReactModal
      {...props}
      isOpen={isOpen}
      className={styles.modal}
      overlayClassName={styles.overlay}
    />
  )
})

Modal.displayName = "Modal"
export default Modal
